import LiftDashboardApiModel from '@/common/models/lift-dashboard/LiftDashboardApiModel';
import ErrorHandler from '@/ErrorHandler';
import GlobalEventBus from '@/GlobalEventBus';
import GlobalEvents from '@/GlobalEvents';
import API from '@/org-app/api';
import {
  createApiAction,
  createDeleteAction,
  createGetAllAction,
  createGetOneAction,
  createPostAction,
  createPutAction,
} from '@/utils/ActionsUtils';
import i18n from '@/vueI18n';

import * as types from './mutation-types';

const actions = {
  createNewLiftDashboard({ commit }, params) {
    const liftDashboard = LiftDashboardApiModel.fromObject(params);
    commit(types.CREATE_LIFTDASHBOARD, liftDashboard);
    return liftDashboard;
  },

  getLiftDashboards: createGetAllAction(
    API.instance.getLiftDashboards,
    types.UPDATE_LIFTDASHBOARDS_LIST,
    'messages.failedToGetLiftDashboards',
    true,
  ),
  getLiftDashboard: createGetOneAction(
    API.instance.getLiftDashboard,
    types.SAVE_LIFTDASHBOARD,
    'messages.failedToGetLiftDashboard',
  ),
  getPublicLiftDashboard: createApiAction(
    API.instance.getPublicLiftDashboard,
    null,
    'messages.failedToGetLiftDashboard',
  ),
  createLiftDashboards: createPostAction(
    API.instance.postLiftDashboards,
    types.SAVE_LIFTDASHBOARD,
    'messages.failedToCreateLiftDashboard',
  ),
  updateLiftDashboard: createPutAction(
    API.instance.putLiftDashboard,
    types.SAVE_LIFTDASHBOARD,
    'messages.failedToUpdateLiftDashboard',
  ),
  deleteLiftDashboard: createDeleteAction(
    API.instance.deleteLiftDashboard,
    types.DELETE_LIFTDASHBOARD,
    'messages.failedToDeleteLiftDashboard',
  ),
  getLiftAnalysisData: createGetAllAction(
    API.instance.getLiftAnalysisData,
    null,
    'messages.failedToGetLiftAnalysisData',
  ),
  getLiftAnalysisSummary: createGetAllAction(
    API.instance.getLiftAnalysisSummary,
    null,
    'messages.failedToGetLiftAnalysisData',
  ),

  updateLiftDashboardName({ commit }, change) {
    commit(types.UPDATE_LIFTDASHBOARD_NAME, change);
  },

  updateLiftDashboardPublicPlaintextPassword({ commit }, change) {
    commit(types.UPDATE_LIFTDASHBOARD_PUBLIC_PLAINTEXT_PASSWORD, change);
  },

  updateLiftDashboardDescription({ commit }, change) {
    commit(types.UPDATE_LIFTDASHBOARD_DESCRIPTION, change);
  },

  updateLiftDashboardJson({ commit }, change) {
    commit(types.UPDATE_LIFTDASHBOARD_JSON, change);
  },

  uploadLiftDashboardFile({ commit }, file) {
    GlobalEventBus.$emit(GlobalEvents.loading);
    return new Promise((resolve, reject) => {
      API.instance.uploadLiftDashboardFile(
        file,
        (data) => {
          resolve(data);
          GlobalEventBus.$emit(GlobalEvents.loaded);
        },
        (error) => {
          const msg = i18n.global.t('messages.failedToSaveLiftDashboard');
          ErrorHandler.showError(msg, error);
          reject(error);
          GlobalEventBus.$emit(GlobalEvents.loaded);
        },
      );
    });
  },
};

export default actions;
